module.exports = __webpack_public_path__ + "static/media/ylhy_bg.238dc33d.png";